var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayCricle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0701 19.0699C22.9801 15.1599 22.9801 8.82993 19.0701 4.92993",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93006 4.92993C1.02006 8.83993 1.02006 15.1699 4.93006 19.0699",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69995 21.4099C9.76995 21.7799 10.8799 21.96 11.9999 21.96C13.1199 21.95 14.2299 21.7799 15.2999 21.4099",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69995 2.59009C9.76995 2.22009 10.8799 2.04004 11.9999 2.04004C13.1199 2.04004 14.2299 2.22009 15.2999 2.59009",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73999 12.0001V10.3302C8.73999 8.25016 10.21 7.40014 12.01 8.44014L13.46 9.28017L14.91 10.1201C16.71 11.1601 16.71 12.8602 14.91 13.9002L13.46 14.7401L12.01 15.5802C10.21 16.6202 8.73999 15.7701 8.73999 13.6901V12.0001Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCricle);
export default __webpack_public_path__ + "static/media/play-cricle.cfe52d1336400199a0145509a6fe15f4.svg";
export { ForwardRef as ReactComponent };